// extracted by mini-css-extract-plugin
export default {"accordionHeader":"rating-assessment-accordion_accordionHeader__pu-GH"};